export const styles = theme => ({
    itemAvatar: {
        backgroundColor: theme.palette.primary.light,
    },
    appBar: {
        backgroundColor: '#212121',
        [theme.breakpoints.up('md')]: {
            paddingLeft: '11%',
            paddingRight: '11%',
        }
    },
    grow: {
        flexGrow: 1,
    },
    growMovile: {
        flexGrow: 1,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    root: {
        flexGrow: 1,
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
        alignItems: 'center',
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    menuButton: {
        marginRight: theme.spacing.unit * 3,
    },
    listItem: {
        padding: '10px',
        paddingLeft: 20,
        [theme.breakpoints.up('sm')]: {
            paddingLeft: 10,
        }
    },
    drawer: {
        padding: '10px',
        backgroundColor: 'transparent',
    },
    itemsMobile: {
        paddingLeft: '20px',
        display: 'flex',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    contentDiv: {
        marginTop: 75,
        [theme.breakpoints.up('md')]: {
            margin: '100px 15% 0',
        },
    },
    menuDiv: {
        top: 0,
        flex: '1 0 auto',
        height: '100%',
        display: 'flex',
        zIndex: 1200,
        width: '80%',
        outline: 'none',
        position: 'fixed',
        overflowY: 'auto',
        flexDirection: 'column',
        left: 0,
        right: 'auto',
        color: '#fafafa',
        backgroundColor: '#212121',
        '& h6': {
            fontSize: '1rem',
            color: '#fafafa',
        },
        [theme.breakpoints.up('sm')]: {
            width: '300px',
            paddingLeft: 30,
            '& h6': {
                fontSize: '18px'
            }
        },
    },
    closeMobileButton: {
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        }
    },
    brandContainer: {
        minHeight: '60px',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 20,
        '& .brand': {
            fontWeight: 'bold',
            fontSize: 20,
        },
        [theme.breakpoints.up('sm')]: {
            paddingLeft: 10,
        }
    },
    // Dialog tech on the way
    techOnTheWayDialog: {
        '& .react-swipeable-view-container': {
            height: '100%',
        },
        '& .contentContainer': {
            paddingLeft: 10,
            paddingRight: 10,
            '& >div': {
                height: '100%'
            }
        },
        '& p': {
            margin: 5,
        },
        '& .dialogContent': {
            width: '90%'
        },
        '& .titleContainer': {
            borderBottom: 'solid 1px #cdcdcdcd',
            '& .backBtn': {
                position: 'absolute',
                top: 15
            },
            '& .title': {
                fontSize: 15,
                textTransform: 'uppercase',
            },
        },
        [theme.breakpoints.up('sm')]: {
            '& .dialogContent': {
                width: '600px',
                height: '70vh',
                maxWidth: '100% !important',
                '&.mapView': {
                    width: '60%',
                    height: '80vh',
                },
            },
        },
    },
    aptmInfo: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        paddingTop: 25,
        '& p': {
            marginLeft: 0
        },
        '& .technicianInfo': {
            display: 'flex',
            alignItems: 'center',
            marginBottom: 20,
            '& .avatar': {
                width: 65,
                height: 65,
                marginRight: 15,
            },
            '& p': {
                fontSize: 13,
            },
            '& .name': {
                fontSize: '1rem',
                fontWeight: 'bold',
            },
        },
        '& address': {
            fontStyle: 'initial',
            marginBottom: 10,
            textAlign: 'center'
        },
        '& .timeToArrive': {
            marginBottom: 15
        },
        '& .devices': {
            '& ul': {
                display: 'flex',
                listStyle: 'none',
                justifyContent: 'flex-start',
                paddingLeft: 0,
                '& li': {
                    marginRight: 15
                }
            }
        },
        [theme.breakpoints.up('sm')]: {
            '& .technicianInfo': {
                marginBottom: 40,
                '& .avatar': {
                    width: 83,
                    height: 83,
                    marginRight: 20,
                },
                '& .name': {
                    marginTop: 3,
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                },
            },
            '& address': {
                marginBottom: 20,
            },
            '& .timeToArrive': {
                marginBottom: 30
            },
            '& .phone': {
                color: '#4A90E2',
            }
        },
    },
    actionContainer: {
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: 15,
        [theme.breakpoints.up('sm')]: {
            paddingBottom: 30
        }
    },
});
